<template>
  <div class="home-page">
    <Announcements v-if="announcements.length > 0" :announcements="announcements" />
    <Banner v-for="(model, idx) in data.banners" :key="idx" :model="model" />
    <SmartLinkStandaloneElement :codename="type.elements.content_.codename">
      <div class="content">
        <RichText v-if="!isEmpty(data.content)" :value="data.content" />
      </div>
    </SmartLinkStandaloneElement>
  </div>
  <SocialSharePreviewBlock v-if="page.elements.social_share_preview.value.length > 0" 
                                 :model="pageStore.getLinkedItem<SocialSharePreviewModel>(page.elements.social_share_preview.value[0]!)"/>
</template>

<script lang="ts" setup>
import { SmartLinkStandaloneElement } from '#components'
import {
  contentTypes,
  type AnnouncementBannerModel,
  type BannerModel,
  type HomepageModel,
  type SocialSharePreviewModel
} from '~~/app/models'
const type = contentTypes.homepage

const pageStore = usePageStore()
const page = pageStore.page as HomepageModel
const announcementStore = useAnnouncementStore()
const announcements = ref<AnnouncementBannerModel[]>([])

const data = {
  banners: pageStore.getListAs<BannerModel>(page?.elements?.hero?.value),
  content: page.elements.content_.value
}
const { registerItem } = useAnchorNavBar()
registerItem(page.elements.content_.linkedItemCodenames)

onMounted(async () => {
  await announcementStore.fetchData()
  announcements.value = announcementStore.getAnnouncements()
})
</script>
